import BasePolicy from '@/policies/BasePolicy.js';

export default class QuizDashboardPolicy extends BasePolicy {
    /**
     *
     * @param user
     * @returns {*}
     */
    viewAny(user) {
        return user.hasPermissionTo('view a quiz attempt');
    }

    canEndQuizzes(user, course) {
        return user.hasPermissionTo('can end quizzes');
    }
}
